import React from 'react';

function TermsModal(props) {
  return (
    <div ref={props.modalRef} className="modal fade" id="modal-terms" tabIndex="-1" role="dialog" aria-labelledby="modal-terms-title" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="h4 modal-title" id="modal-terms-title">Terms and Conditions</h2>
          </div>
          <div className="modal-body">
            <p className="text-muted small mb-3">Last updated: July 9, 2026</p>
            <p>Welcome to Jashsoft. By creating an account and using our investment portfolio management service, you agree to the following terms and conditions.</p>

            <h3 className="h6 mt-4">1. Acceptance of Terms</h3>
            <p>By registering for and using Jashsoft, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree, you may not use the service.</p>

            <h3 className="h6 mt-4">2. Description of Service</h3>
            <p>Jashsoft provides tools to track, manage, and analyze your personal investment portfolio. The service is intended for informational and record-keeping purposes only and does not constitute financial, investment, tax, or legal advice.</p>

            <h3 className="h6 mt-4">3. Account Registration</h3>
            <p>You agree to provide accurate and complete information when creating your account and to keep your account credentials confidential. You are responsible for all activity that occurs under your account.</p>

            <h3 className="h6 mt-4">4. User Responsibilities</h3>
            <p>You are solely responsible for the accuracy of the transaction and portfolio data you enter. You agree not to use the service for any unlawful purpose or in any way that could damage, disable, or impair the service.</p>

            <h3 className="h6 mt-4">5. Market Data and Third-Party Information</h3>
            <p>Market data and stock information displayed within the service may be sourced from third parties and is provided on an &quot;as is&quot; basis. Jashsoft does not guarantee the accuracy, timeliness, or completeness of such data.</p>

            <h3 className="h6 mt-4">6. No Investment Advice</h3>
            <p>Nothing on Jashsoft should be interpreted as a recommendation to buy, sell, or hold any security. Past performance of investments is not indicative of future results. You should consult a qualified financial advisor before making investment decisions.</p>

            <h3 className="h6 mt-4">7. Limitation of Liability</h3>
            <p>To the fullest extent permitted by law, Jashsoft and its operators shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the service, including any investment losses based on information displayed in the application.</p>

            <h3 className="h6 mt-4">8. Modifications</h3>
            <p>We reserve the right to modify these Terms and Conditions at any time. Continued use of the service after changes are posted constitutes your acceptance of the revised terms.</p>

            <h3 className="h6 mt-4">9. Termination</h3>
            <p>We may suspend or terminate your access to the service at any time for violation of these terms or for any other reason at our discretion. You may stop using the service at any time.</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary btn-block" onClick={props.onAccept}>Accept</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
